// CoreUI Pro source reference: /Users/guochunzhong/git/oss/coreui-pro/js/src/modal.js
import BackdroppedComponent from "./backdropped-component"

const openModals = new Set()

export default class Modal extends BackdroppedComponent {
  static componentName = "modal"
  static defaults = { backdrop: true, keyboard: true, focus: true }

  constructor(element, config = {}) {
    super(element, config)
    this.listen(element, "click", (event) => {
      if (event.target === element) this.dismissBackdrop()
    })
    this.listen(element, "keydown", (event) => {
      if (event.key !== "Escape" || !this.shown) return
      if (this.config.keyboard) this.hide()
      else this.emit("hidePrevented")
    })
  }

  show(relatedTarget = null) {
    if (this.shown || this.transitioning || this.emit("show", { relatedTarget }, { cancelable: true }).defaultPrevented)
      return
    this.shown = true
    this.transitioning = true
    this.previouslyFocused = relatedTarget || document.activeElement
    openModals.forEach((modal) => {
      if (modal !== this) {
        modal.releaseFocus(false)
        modal.hide()
      }
    })
    openModals.add(this)
    this.lockScroll()
    document.body.classList.add("modal-open")
    this.createBackdrop("modal-backdrop")
    this.element.style.display = "block"
    this.element.removeAttribute("aria-hidden")
    this.element.setAttribute("aria-modal", "true")
    this.element.setAttribute("role", "dialog")
    this.element.scrollTop = 0
    this.element.offsetHeight
    this.element.classList.add("show")
    if (this.config.focus) this.activateFocusTrap()
    this.afterTransition(
      this.element.querySelector(".modal-dialog") || this.element,
      () => {
        this.transitioning = false
        this.emit("shown", { relatedTarget })
        if (this.pendingHide) {
          this.pendingHide = false
          this.hide()
        }
      },
      this.element.classList.contains("fade"),
    )
  }

  hide() {
    if (this.shown && this.transitioning) {
      this.pendingHide = true
      return
    }
    if (!this.shown || this.transitioning || this.emit("hide", {}, { cancelable: true }).defaultPrevented) return
    this.shown = false
    this.transitioning = true
    this.releaseFocus(false)
    this.element.classList.remove("show")
    this.afterTransition(
      this.element,
      () => {
        this.element.style.display = "none"
        this.element.setAttribute("aria-hidden", "true")
        this.element.removeAttribute("aria-modal")
        this.element.removeAttribute("role")
        this.removeBackdrop()
        this.unlockScroll()
        openModals.delete(this)
        if (!openModals.size) document.body.classList.remove("modal-open")
        this.transitioning = false
        this.releaseFocus()
        this.emit("hidden")
      },
      this.element.classList.contains("fade"),
    )
  }

  toggle(relatedTarget = null) {
    this.shown ? this.hide() : this.show(relatedTarget)
  }

  dispose() {
    if (this.signal.aborted) return
    openModals.delete(this)
    if (!openModals.size) document.body.classList.remove("modal-open")
    super.dispose()
  }
}
